import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * AdminRoute Component
 * Route guard that requires admin role
 * Redirects to /forbidden if user is not admin
 * Redirects to /login if user is not authenticated
 */
const AdminRoute: React.FC = () => {
  const { isAuthenticated, user } = useAuth();

  // Not authenticated - redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Authenticated but not admin - redirect to forbidden
  if (user?.role !== 'admin') {
    return <Navigate to="/forbidden" replace />;
  }

  // Admin user - render child routes
  return <Outlet />;
};

export default AdminRoute;
